import { render, staticRenderFns } from "./DispatchContacts.vue?vue&type=template&id=2f8ac609&scoped=true"
import script from "./DispatchContacts.vue?vue&type=script&lang=js"
export * from "./DispatchContacts.vue?vue&type=script&lang=js"
import style0 from "./DispatchContacts.vue?vue&type=style&index=0&id=2f8ac609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ac609",
  null
  
)

/* custom blocks */
import block0 from "./DispatchContacts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports